import React from 'react';
import DataGrid from '@dataGrid';
import TractorGridConfig from './GridConfig';
import { withUserProfile } from '../../../../../userProfile/userProfileContext';
import { withFeatureFlags } from '../../../../../userProfile/featureFlagsContext';
import { compose } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import styles from '../styles';
import StatusBar from '@dataGrid/components/StatusBar';
import { isEqual } from 'lodash/lang';
import { getFilteredData } from '../../../../common/filterUtilities';
import Events from '../../../../../utilities/EventEmitter';
import appConstants from '../../../../../appConstants';
class TractorGrid extends React.Component {
  constructor(props) {
    super(props);
    this.gridConfig = new TractorGridConfig({
      showTrailerScacColumn: this.props.showTrailerScac,
      showTrailerScacValue: this.props.featureFlags.isFeatureEnabled(
        appConstants.features.ShowTrailerScac
      ),
      userConfig: this.props.userData.userProfile?.columnPref
    });
    this.state = {
      quickFilter: ''
    };
  }

  componentDidMount() {
    this.props.glEventHub.on('UpdateTractorQuickFilter', this.updatedQuickFilter);
    Events.on('AssetTractorUpdate', this.updateTractorList);
    Events.on('AssetUpdateDefects', this.updateTractorDefects);
  }

  componentDidUpdate(prevProps) {
    if (!isEqual(this.props.selectedAssets, prevProps.selectedAssets)) {
      this.updateSelection();
    }
  }
  componentWillUnmount() {
    this.props.glEventHub.off('UpdateTractorQuickFilter', this.updatedQuickFilter);
    Events.off('AssetTractorUpdate', this.updateTractorList);
    Events.off('AssetUpdateDefects', this.updateTractorDefects);
  }

  constructStatusBar = (filteredData) => {
    return [
      {
        label: filteredData.length + ' Tractor',
        filterCondition: ''
      }
    ];
  };

  updateSelection = () => {
    if (this.gridApi) {
      this.gridApi.forEachNode((node) => {
        if (this.props.selectedAssets?.includes(node.data.tractorId)) {
          this.gridApi.ensureIndexVisible(node.rowIndex);
          node.setSelected(true, false, true);
        } else {
          node.setSelected(false, false, true);
        }
      });
      this.gridApi.dispatchEvent({
        type: 'selectionChanged',
        api: this.gridApi
      });
    }
  };

  getFilteredTractors = () => {
    if (!this.state.quickFilter) {
      return this.props.tractorList || [];
    }
    return getFilteredData(this.props.tractorList || [], this.state.quickFilter);
  };

  onSelectionChanged = () => {
    if (this.props.assetSelectedOnGrid && this.gridApi) {
      const selectedTractor = this.gridApi.getSelectedRows().map((tractor) => tractor);
      this.props.assetSelectedOnGrid(selectedTractor);
    }
  };
  onGridReady = ({ api }) => {
    this.gridApi = api;
    this.props.setGridApi(api);
  };

  updatedQuickFilter = (quickFilter) => {
    this.setState({
      quickFilter
    });
  };

  updateTractorList = (data) => {
    this.props.updateEquipmentList({
      equipmentNumber: data?.tractorNumber,
      equipmentId: data?.tractorId,
      success: data.success || false
    });
  };

  updateTractorDefects = ({ tractor }) => {
    if (tractor) {
      this.updateTractorList({ ...tractor, success: true });
    }
  };

  render() {
    const tractorList = this.getFilteredTractors();
    const { classes, searchText, showErrorMessage, isAssetUpdateFormOpen } = this.props;
    return (
      <div className={classes.dataGrid}>
        <DataGrid
          onGridReady={this.onGridReady}
          defaultColDef={this.gridConfig.config.defaultColDef}
          columnDefs={this.gridConfig.config.columns}
          columnTypes={this.gridConfig.config.columnTypes}
          config={this.gridConfig.config}
          rowSelection={this.gridConfig.config.rowSelection}
          rowDeselection={this.gridConfig.config.rowDeselection}
          rowData={tractorList}
          onRowDataUpdated={this.updateSelection}
          onSelectionChanged={this.onSelectionChanged}
          deltaRowDataMode={true}
          getRowId={(params) => params.data.tractorId}
          panelLabel={(filteredData) => <StatusBar data={this.constructStatusBar(filteredData)} />}
          isExternalFilterPresent={() => false}
          quickFilterText={searchText}
          showErrorMessage={showErrorMessage}
          suppressRowClickSelection={isAssetUpdateFormOpen}
        />
      </div>
    );
  }
}
export default compose(withUserProfile, withFeatureFlags, withStyles(styles))(TractorGrid);
